import { SET_WIDGET_INFO } from '../actions/types';

export default function widgetInfo(state = {}, action) {
	switch (action.type) {
		case SET_WIDGET_INFO:
			return action.payload;
		default:
			return state;
	}
}
